/**
 * Sorrel House · <sh-collection> : menu de tri (bouton + liste de liens) et « Load more ».
 * Load more : charge la page suivante par le rendu de section (?section_id=), ajoute les tuiles a la
 * grille, met a jour le compteur, la barre et le lien ; l'URL ne change pas. Sans JavaScript, le lien
 * ?page=n reste un vrai lien. Jamais de defilement infini.
 */
class ShCollection extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
    this.onDoc = (e) => {
      const list = this.querySelector('.sh-coll__sortlist');
      if (list && !list.hidden && !this.querySelector('.sh-coll__sort')?.contains(e.target)) this.toggleSort(false);
    };
    this.onKey = (e) => { if (e.key === 'Escape') this.toggleSort(false); };
    document.addEventListener('click', this.onDoc);
    document.addEventListener('keydown', this.onKey);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    document.removeEventListener('click', this.onDoc);
    document.removeEventListener('keydown', this.onKey);
  }
  onClick = (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    if (t.closest('[data-sh-sort-toggle]')) { e.preventDefault(); this.toggleSort(); return; }
    const more = t.closest('a[data-sh-more]');
    if (more && !(e.metaKey || e.ctrlKey || e.shiftKey)) { e.preventDefault(); this.loadMore(more); }
  };
  toggleSort(force) {
    const btn = this.querySelector('[data-sh-sort-toggle]');
    const list = this.querySelector('.sh-coll__sortlist');
    if (!btn || !list) return;
    const open = typeof force === 'boolean' ? force : list.hidden;
    list.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
  }
  async loadMore(link) {
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    try {
      const url = new URL(link.href, window.location.href);
      url.searchParams.set('section_id', this.dataset.section || '');
      const res = await fetch(url.toString());
      if (!res.ok) throw new Error(String(res.status));
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const grid = this.querySelector('[data-sh-grid]');
      const next = doc.querySelector('[data-sh-grid]');
      if (grid && next) {
        for (const tile of [...next.children]) {
          if (tile.classList.contains('sh-settile')) continue;
          tile.querySelectorAll('img[loading="eager"]').forEach((img) => img.setAttribute('loading', 'lazy'));
          grid.append(tile);
        }
      }
      const newCount = doc.querySelector('[data-sh-count]');
      this.querySelectorAll('[data-sh-count]').forEach((c) => { if (newCount) c.textContent = newCount.textContent; });
      const newFill = doc.querySelector('[data-sh-progress]');
      const fill = this.querySelector('[data-sh-progress]');
      if (fill && newFill) fill.setAttribute('style', newFill.getAttribute('style') || '');
      const newMore = doc.querySelector('a[data-sh-more]');
      if (newMore) { link.href = newMore.getAttribute('href') || link.href; link.removeAttribute('aria-busy'); }
      else link.remove();
    } catch (err) {
      window.location.href = link.href;
    }
  }
}
if (!customElements.get('sh-collection')) customElements.define('sh-collection', ShCollection);
